export default "__VITE_ASSET__Bk3G8RvL__"